<template lang="html">
    <div class="flex-col editApp-container">
        <div class="breadCrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>{{$t('message.merchant')}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{$t('message.merchantManage')}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{$t('message.merchantInformation')}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="editApp-body-container">
            <div class="edit-body verifone-panel">
                <div class="flex-row edit-app-item">
                    <div class="item-name"><span class="redStar">*</span>{{$t('message.merchantName')}}</div><el-input v-model="merchantName" :placeholder="$t('message.charTip50')" maxLength="50" class="input-margin"></el-input>
                </div>
                <div class="flex-row edit-app-item">
                    <div class="item-name"><span class="redStar">*</span>{{$t('message.companyName')}}</div>
                    <el-input class="input-margin" v-model="companyName" :placeholder="$t('message.charTip50')" oninput="if(value.length > 60) value = value.slice(0, 60)" maxLength="50"></el-input>
                </div>
                <div class="flex-row edit-app-item">
                    <div class="item-name"><span class="redStar">*</span>{{$t('message.country')}}</div> <el-select class="doubleSelect" v-model="nowCountry" :placeholder="$t('message.pleaseChoose')" @change="loadState"><el-option v-for="item in countryList" :key="item.id" :label="item.name" :value="item.id"> </el-option> </el-select>

                    <div class="double-item-name"><span class="redStar">*</span>{{$t('message.state')}}</div> <el-select class="doubleSelect" v-model="nowState" :placeholder="$t('message.pleaseChoose')" @change="loadCity"><el-option v-for="item in stateList" :key="item.id" :label="item.name" :value="item.id"> </el-option> </el-select>
                </div>
                <div class="flex-row edit-app-item">
                    <div class="item-name"><span class="redStar">*</span>{{$t('message.city')}}</div> <el-select class="doubleSelect" v-model="nowCity" :placeholder="$t('message.pleaseChoose')" @change="loadDistrict"><el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id"> </el-option> </el-select>

                    <div class="double-item-name"><span class="redStar">*</span>{{$t('message.district')}}</div> <el-select class="doubleSelect" v-model="nowDistrict" :placeholder="$t('message.pleaseChoose')"><el-option v-for="item in districtList" :key="item.id" :label="item.name" :value="item.id"> </el-option> </el-select>
                </div>
                <div class="flex-row edit-app-item">
                    <div class="item-name"><span class="redStar">*</span>{{$t('message.address')}}</div>
                    <el-input class="input-margin" v-model="address" type="textarea" :rows="2" :placeholder="$t('message.charTip200')" oninput="if(value.length > 200) value = value.slice(0, 200)"></el-input>
                </div>
                <div class="flex-row edit-app-item">
                    <div class="item-name">
                        <!-- <span class="redStar">*</span> -->
                        {{$t('message.postcode')}}</div>
                    <el-input class="input-margin" v-model="postCode" :placeholder="$t('message.charTip50')" maxLength="50"></el-input>
                </div>
                <div class="flex-row edit-app-item">
                    <div class="item-name"><span class="redStar">*</span>{{$t('message.type')}}</div><el-select class="doubleSelect" v-model="typeId" :placeholder="$t('message.pleaseChoose')">
                        <el-option v-for="item in businessList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="flex-row edit-app-item">
                    <div class="item-name"><span class="redStar">*</span>{{$t('message.contactName')}}</div>
                    <el-input class="double-input" v-model="contactFirstName" :placeholder="$t('message.firstName')" maxLength="50"></el-input>
                    <el-input class="double-input" v-model="contactLastName" :placeholder="$t('message.lastName')" maxLength="50"></el-input>
                </div>
                <div class="flex-row edit-app-item">
                    <div class="item-name"><span class="redStar">*</span>{{$t('message.email')}}</div>
                    <el-input class="input-margin" v-model="email" :placeholder="$t('message.charTip50')" maxLength="50"></el-input>
                </div>
                <div class="flex-row edit-app-item">
                    <div class="item-name"><span class="redStar">*</span>{{$t('message.phoneNo')}}</div>
                    <el-input class="Code" v-model="region" :placeholder="$t('message.areaCode')"></el-input>
                    <el-input  v-model="mobilePhone" :placeholder="$t('message.charTip50')" maxLength="50" style="width: 348px;"></el-input>
                </div>
                <div class="flex-row edit-app-item">
                    <div class="item-name">
                        <!-- <span class="redStar">*</span> -->
                        {{$t('message.telephoneNo')}}</div>
                    <el-input  class="Code" v-model="landline" :placeholder="$t('message.landlineNumber')"></el-input>
                    <el-input  v-model="telePhone" :placeholder="$t('message.charTip50')" maxLength="50" style="width: 348px;"></el-input>
                </div>
                <div class="flex-row footer-contain">
                    <el-button type="primary" plain icon="el-icon-close" @click="handleCancel" class="verifone-btn" style="margin-right: 10px;">{{$t('message.cancel')}}</el-button>
                    <el-button v-if="queryFlag" type="primary" icon="el-icon-document" class="verifone-btn" @click="saveMerchant">{{$t('message.submit')}}</el-button>
                    <el-button v-else disabled type="primary" icon="el-icon-document" class="verifone-btn" @click="saveMerchant">{{$t('message.submit')}}</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script >
import ElButton from "element-ui/packages/button/src/button";

export default {
    components: {ElButton},
    data () {
        return  {
            count:0,
            id:'',
            merchantName:'',
            companyName:'',
            address:'',
            postCode:'',
            typeId:'',
            contactFirstName:'',
            contactLastName:'',
            email:'',
            mobilePhone:'',
            telePhone:'',
            nowCountry: null,
            countryList:[],
            nowState: null,
            stateList:[],
            nowCity: null,
            cityList:[],
            nowDistrict:'',
            districtList:[],
            queryFlag: false,
            landline :'',//座机区号
            region:'',//电话区号
            addSuccess: this.$t('message.addSuccess'),
            modifySuccess: this.$t('message.modifySuccess'),
            businessList: [ {
                value: 1,
                label: 'Enable'
            },{
                value: 0,
                label: 'Disable'
            }],
            appEditType:'0',
            pickerOptions1: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 3600 * 1000 * 24;
                }
            }
        }
    },
    mounted() {
        this.loadBusinessType();
        this.initCountryList();
        this.initData();
        this.setQuery();
        this.queryCountry();
    },
  computed:{
    changeData(){
      const {merchantName,companyName,address,postCode,typeId,contactFirstName,contactLastName,email,mobilePhone,telePhone,nowCountry,nowState,nowCity}=this
      return{
        merchantName,companyName,address,postCode,typeId,contactFirstName,contactLastName,email,mobilePhone,telePhone,nowCountry,nowState,nowCity
      }
    }
  },
  watch:{
    changeData: {
      handler(oldVal, newVal) {
        if (oldVal!=newVal && newVal.merchantName=="") {
            this.count == 0;
        } else if (newVal == oldVal) {
          this.count == 0;
        }else  {
          this.count++;
        }
      },
      deep: true
    }
  },
    methods:{
        setQuery() {
            let roleArr = sessionStorage.getItem('verifoneRoleList').split(',').map(str => parseInt(str));
            this.queryFlag = !roleArr.includes(11);
        },
        initData(){
            let id = this.$route.query.id;
            if(id=='newMerchant') {

                this.appEditType ='0';
            }else {
                this.detailMerchant(id);
                this.appEditType ='1';
            }
        },
      /*退出编辑提示*/
      handleCancel() {
        if(this.count>0) {
          this.$confirm(this.$i18n.t('message.createBack'), this.warn, {
            confirmButtonText: this.$i18n.t('message.yes'),
            cancelButtonText: this.$i18n.t('message.no'),
            type: 'warning'
          }).then(() => {
            this.$router.replace('/merchantlist');
          })
        }else{
          this.$router.replace('/merchantlist');
        }
      },
        saveMerchant(){
            if(this.appEditType === '0') {
                this.addMerchant();
            }
            else if(this.appEditType === '1') {
                this.editMerchant();
            }
        },
        queryCountry() {
            this.$axios({
                method: 'post',
                url: '/marketplace/merchant/country',
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')}
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    this.nowCountry = response.data.countryId;
                    this.loadState();
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        detailMerchant(id){
            let that = this,
            obj = {
                id: id
            };

            this.$axios({
                method: 'post',
                url: '/marketplace/merchant/detail',
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
                data: obj
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    that.id = response.data.merchant.id;
                    that.merchantName = response.data.merchant.merchantName;
                    that.companyName = response.data.merchant.companyName;
                    that.address = response.data.merchant.address;
                    that.postCode = response.data.merchant.postCode;
                    that.typeId = response.data.merchant.typeId;
                    that.contactFirstName = response.data.merchant.contactFirstName;
                    that.contactLastName = response.data.merchant.contactLastName;
                    that.email = response.data.merchant.email;
                    that.mobilePhone = response.data.merchant.mobilePhone;
                    that.telePhone = response.data.merchant.telePhone;
                    this.region = response.data.merchant.mobilePhoneCode;
                    this.landline = response.data.merchant.telePhoneCode;
                    that.nowCountry = response.data.merchant.countryId;
                    that.nowState = response.data.merchant.stateId;
                    that.nowCity = response.data.merchant.cityId;
                    that.nowDistrict = response.data.merchant.districtId;
                    this.loadState();
                    this.loadCity();
                    this.loadDistrict();
                }
            }).catch((err) => {
                console.log(err);
            });
        },

        addMerchant(){
            if(this.mobilePhone=="" || this.mobilePhone==null ){
               this.$message({
                 type: 'warning',
                 message: this.$t('message.phoneCheck'),
                 duration: '2000'
               });
              return;
            }

            var numReg = /^[0-9]*$/
            var numRe = new RegExp(numReg)
            if (!numRe.test(this.region)) {
              this.$message({
                type: 'warning',
                message: this.$t('message.areaTypeCheck'),
                duration: '2000'
              })
              return;
            }
            if (!numRe.test(this.landline)) {
              this.$message({
                type: 'warning',
                message: this.$t('message.areaTypeCheck'),
                duration: '2000'
              })
              return;
            }

            console.log("addMerchant");
            let that = this,

                obj = {
                    merchantName:that.merchantName,
                    companyName:that.companyName,
                    address:that.address,
                    postCode:that.postCode,
                    typeId:that.typeId,
                    contactFirstName:that.contactFirstName,
                    contactLastName:that.contactLastName,
                    email:that.email,
                    mobilePhone:that.mobilePhone,
                    telePhone: that.telePhone,
                    region:that.region ,
                    landline:that.landline,
                    countryId:that.nowCountry === that.$t('message.pleaseChoose') ? '':that.nowCountry,
                    stateId:that.nowState  === that.$t('message.pleaseChoose') ? '':that.nowState,
                    cityId:that.nowCity  === that.$t('message.pleaseChoose') ? '':that.nowCity,
                    districtId:that.nowDistrict  === that.$t('message.pleaseChoose') ? '':that.nowDistrict,
                };

            this.$axios({
                method: 'post',
                url: '/marketplace/merchant/add',
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
                data: obj
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    this.$message({
                        type: "success",
                        message: this.addSuccess,
                        duration:'3000',
                    });

                  window.history.go(-1);
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        editMerchant(){
            console.log("editMerchant");
            console.log("id"+this.id);

          if(this.mobilePhone=="" || this.mobilePhone==null ){
             this.$message({
               type: 'warning',
               message: this.$t('message.phoneCheck'),
               duration: '2000'
             });
            return;
          }

          var numReg = /^[0-9]*$/
          var numRe = new RegExp(numReg)
          if (!numRe.test(this.region)) {
            this.$message({
              type: 'warning',
              message: this.$t('message.areaTypeCheck'),
              duration: '2000'
            })
            return;
          }

            let that = this,
                obj = {
                    id:this.$route.query.id,
                    merchantName:that.merchantName,
                    companyName:that.companyName,
                    address:that.address,
                    postCode:that.postCode,
                    typeId:that.typeId,
                    contactFirstName:that.contactFirstName,
                    contactLastName:that.contactLastName,
                    email:that.email,
                    mobilePhone:that.mobilePhone,
                    telePhone:that.telePhone,
                    region:that.region,
                    landline:that.landline,
                    countryId:that.nowCountry === that.$t('message.pleaseChoose') ? '':that.nowCountry,
                    stateId:that.nowState === that.$t('message.pleaseChoose') ? '':that.nowState,
                    cityId:that.nowCity === that.$t('message.pleaseChoose') ? '':that.nowCity,
                    districtId:that.nowDistrict === that.$t('message.pleaseChoose') ? '':that.nowDistrict,
                };

            this.$axios({
                method: 'post',
                url: '/marketplace/merchant/edit',
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
                data: obj
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    this.$message({
                        type: "success",
                        message: this.modifySuccess,
                        duration:'3000',
                    });
                    window.history.go(-1);
                }
            }).catch((err) => {
                console.log(err);
            });
        },

        loadBusinessType(){
            const that =this;

            this.$axios({
                method: 'post',
                url: '/marketplace/common/query/business',
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')}
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    that.businessList = response.data.businessTypes;
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        initCountryList(){
            const that =this;

            this.$axios({
                method: 'post',
                url: '/marketplace/common/query/country',
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')}
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    that.countryList = response.data.countries;
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        loadState(){
            console.log("loadState");
            console.log("that.nowCountry"+this.nowCountry);
            let that = this,
                obj = {
                    countryId:that.nowCountry
                };

            this.$axios({
                method: 'post',
                url: '/marketplace/common/query/state',
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
                data: obj
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    that.stateList = response.data.states;
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        loadCity(){
            console.log("loadCity");
            console.log("that.nowCountry"+this.nowState);
            let that = this,
                obj = {
                    stateId:that.nowState
                };

            this.$axios({
                method: 'post',
                url: '/marketplace/common/query/city',
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
                data: obj
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    that.cityList = response.data.cities;
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        loadDistrict(){
            console.log("loadDistrict");
            console.log("that.nowCountry"+this.nowCity);
            let that = this,
                obj = {
                    cityId:that.nowCity
                };

            this.$axios({
                method: 'post',
                url: '/marketplace/common/query/district',
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
                data: obj
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    that.districtList = response.data.districts;
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        realLength(str){
            return str.replace(/[^\x00-\xff]/g,"**").length;
        },
        checkInput(obj,num){
            if(this.realLength(obj)>num){
                obj.slice(0, num);
            }
        },
    },
}

</script>

<style scoped lang="css">
.editApp-container {
    /* overflow: hidden; */
    display: flex;
    display: -webkit-flex;
    align-items: center;
    width: 100%;
    font-family: 'Arial';
    padding: 0 0 10px 0;
}
.editApp-body-container {
    width:100%;
}
.redStar {
    color: red;
    font-size: 20px;
    font-weight: bold;
    margin-top: 5px;
    margin-right: 10px;
}
.title {
    padding-left:0;
}
.avatar-uploader,.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader,.el-upload:hover {
    border-color: #409EFF;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
}
.avatar {
    width: 100px;
    height: 100px;
    display: block;
}
.edit-body {
    width: 100%;
    line-height: 20px;
    text-align: center;
    box-shadow: 1px 1px 1px 1px rgba(170, 170, 170, 1);
    border: 1px solid rgba(255, 255, 255, 0);
    background: #fff;
    padding: 20px 35px 20px 100px;
}
.app-file-container {
    /*border-bottom:1px solid #BBBBBB;*/
}
.app-message-container {
    padding:10px 0;
}
.left-app-message-container,.right-app-message-container{
    flex: 1;
    padding-right: 30px;
}
.right-app-message-container {
    justify-content: space-between;
    padding-left: 30px;
}
.edit-app-item {
    padding: 12px 0;
    align-items: center;
}
.upload-demo {
    align-items: center;
}
.app-div-name {
    line-height: 26px;
    color: rgba(16, 16, 16, 1);
    font-size: 18px;
    text-align: left;
}
.item-name {
    width: 200px;
    font-family: 'Arial';
    font-size: 14px;
    text-align: right;
    margin-right: 10px;
}
.long-item-name {
    width: 220px;
    font-family: 'Arial';
    font-size: 14px;
    text-align: left;
}
.el-input,.el-textarea{
    width: 16vw;
}
.save-app-btn {
    width: 100px;
    height: 40px;
    border-radius: 4px;
    background-color: #58D56D;
    color: rgba(255, 255, 255, 1);
    font-size: 16px;
    text-align: center;
    font-family: Microsoft Yahei;
    border: 1px solid rgba(187, 187, 187, 1);
}
.footer-contain {
    justify-content: flex-end;
}
.input-margin {
    margin-right: 20px;
    width: 488px!important;
}
.doubleSelect {
    width: 200px!important;
    margin-right: 10px;
}
.double-item-name {
    width: 80px;
    font-size: 14px;
}
.double-input {
    width: 200px!important;
    margin-right: 10px;
}
.Code{
  width: 140px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/MerchantAdde.vue